import {
  AddExtraComplete,
  DeleteExtraComplete,
  DeleteExtrasComplete,
  LoadExtrasByIdsComplete,
  LoadExtrasComplete,
  UpdateExtraComplete,
} from './actions'
import { adapter, initialState, State } from './state'
import * as R from 'ramda'
import { Action, createReducer, on } from '@ngrx/store'

export const reducer = createReducer(
  initialState,
  on(LoadExtrasComplete, (state, { extras }) => adapter.upsertMany(extras, R.merge(state, { isLoaded: true }))),
  on(LoadExtrasByIdsComplete, (state, { extras }) => adapter.addMany(extras, state)),
  on(AddExtraComplete, (state, { extra }) => adapter.addOne(extra, state)),
  on(UpdateExtraComplete, (state, { update }) => adapter.updateOne(update, state)),
  on(DeleteExtraComplete, (state, { id }) => adapter.removeOne(id, state)),
  on(DeleteExtrasComplete, (state, { ids }) => adapter.removeMany(ids, state))
)

export function extraReducer(state: State | undefined, action: Action) {
  return reducer(state, action)
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors()
